var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./Cbs.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b7a47e96\"}!../node_modules/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../node_modules/vue-loader/lib/selector?type=template&index=0!./Cbs.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/Cbs.vue
// module id = 192
// module chunks = 0